<template>
	<div>
		<firstsceenimage :imgobj='imgobj'></firstsceenimage>
		<adword title="华为云盘古大模型" subtitle="盘古大模型由NLP大模型、CV大模型、多模态大模型、科学计算大模型多个大模型构成，通过模型泛化，解决传统AI作坊式开发模式下不能解决的
			AI规模化、产业化难题。AI开发正面临场景碎片化，难以规模复制、行业知识与AI技术结合困难、自身可解释性差等问题。盘古大模型从应用技术手
			段，解决AI规模化、产业化的难题" slotheight="150" style="margin-top: 100px;margin-bottom: 100px;"></adword>

		<!-- 优势 -->
		<div ref="ai3" style="z-index:0;">
			<adword title="盘古大模型开发AI优势" :backimg="aibackimg">
				<div class="container" style="margin-top: 70px;">
					<div class="row">
						<div class="col-md-4">
							<transition name="adfadey1">
								<div v-if="ai3show1" class="boxshadow"
									:style="{backgroundImage: 'url('+aibackimg2+') ' }"
									style="background-repeat:no-repeat; background-position:right bottom ;padding: 35px 60px 20px 60px; height: 200px;background-color: white;">
									<img style="width: 60px;height: 60px;" src="../../static/成本极省ico.png">
									<div
										style="font-weight: bold;margin: 8px 0px 8px 0px;font-size: 16px;letter-spacing: 3px;">
										成本极省</div>
									<div style="font-size: 12px;color: #999999;">模型具备极佳泛化能力，场景覆盖率提升10倍，节省培训投入</div>
								</div>
							</transition>
						</div>
						<div class="col-md-4">
							<transition name="adfadey1">
								<div v-if="ai3show2" class="boxshadow"
									:style="{backgroundImage: 'url('+aibackimg2+') ' }"
									style="background-repeat:no-repeat; background-position:right bottom ;padding: 35px 60px 20px 60px; height: 200px;background-color: white;">
									<img style="width: 60px;height: 60px;" src="../../static/性能极佳ico.png">
									<div
										style="font-weight: bold;margin: 8px 0px 8px 0px;font-size: 16px;letter-spacing: 3px;">
										性能极佳</div>
									<div style="font-size: 12px;color: #999999;">获得冯家模型性能，效率提升10-100倍</div>
								</div>
							</transition>
						</div>
						<div class="col-md-4">
							<transition name="adfadey1">
								<div v-if="ai3show3" class="boxshadow"
									:style="{backgroundImage: 'url('+aibackimg2+') ' }"
									style="background-repeat:no-repeat; background-position:right bottom ;padding: 35px 60px 20px 60px; height: 200px;background-color: white;">
									<img style="width: 60px;height: 60px;" src="../../static/训练极速ico.png">
									<div
										style="font-weight: bold;margin: 8px 0px 8px 0px;font-size: 16px;letter-spacing: 3px;">
										训练极速</div>
									<div style="font-size: 12px;color: #999999;">流水线工具集成，训练更快</div>
								</div>
							</transition>
						</div>
					</div>
				</div>
				<div v-if="!ai3show1" style="height: 200px;"> </div>
				<div style=" text-align: center;margin-top: 70px;z-index: 110;">
					<!--  style="width: 758px;height: 758px;"  -->
					<img class="aihuawei" style="width: 55%;width: 55%;" src="../../static/C2M实验室2.0圆盘.png">
					<div style="width: 80%;   margin-top: 30px; margin-left: auto;margin-right: auto;">
						星链与华为进行联合创新，基于华为云盘古大模型开发3D脚型扫描技术，AI时尚趋势数据挖掘系统、C2M数字化订货系统和柔性智能制造管控系统，可为鞋产业提升基于数字驱动的C2M数字化全链路服务，包括“数字研发、数字工厂、数字零售”，实现“个性化、小批量、多批次、快生产、云工厂”的产业数字化模式，构建C2M产业互联网新生态
					</div>
				</div>
			</adword>
		</div>
		<!-- 优势end -->


		<!-- ai tab ad -->
		<div v-if="isShowNavAD">
			<div style="margin-top: 60px;">
				<div class="flexcenter" style=" overflow:hidden;">
					<div v-bind:class="[selecttabindex==0 ? 'tabselect' :  'tab']" @click="selecttab(0)">
						AI流行趋势</div>
					<div v-bind:class="[selecttabindex==1 ? 'tabselect' :  'tab']" @click="selecttab(1)">
						AI数字化订货系统</div>
					<div v-bind:class="[selecttabindex==2 ? 'tabselect' :  'tab']" @click="selecttab(2)">
						AI辅助设计平台</div>
					<div v-bind:class="[selecttabindex==3 ? 'tabselect' :  'tab']" @click="selecttab(3)">
						工业互联网</div>
					<div v-bind:class="[selecttabindex==4 ? 'tabselect' :  'tab']" @click="selecttab(4)">
						3D扫描</div>
					<div v-bind:class="[selecttabindex==5 ? 'tabselect' :  'tab']" @click="selecttab(5)">
						AI版权保护</div>
				</div>
				<div class="flexcenter" style="height: 8px; overflow:hidden;">
					<div v-bind:class="[selecttabindex==0 ? 'tabselect2' :  'tab']">
					</div>
					<div v-bind:class="[selecttabindex==1 ? 'tabselect2' :  'tab']">
					</div>
					<div v-bind:class="[selecttabindex==2 ? 'tabselect2' :  'tab']">
					</div>
					<div v-bind:class="[selecttabindex==3 ? 'tabselect2' :  'tab']">
					</div>
					<div v-bind:class="[selecttabindex==4 ? 'tabselect2' :  'tab']">
					</div>
					<div v-bind:class="[selecttabindex==5 ? 'tabselect2' :  'tab']">
					</div>
				</div>
			</div>
			<div v-if="selecttabindex==0" style="background: linear-gradient(315deg, #020F39 0%, #263E8B 100%); ">
				<div class="container flexspacebetween">
					<!-- <div class="row"> -->
					<div style="width: 50%;opacity: 0.7;">
						<div style="color: white;padding:90px 75px 90px 0px;">
							利用人工智能和数据挖掘领域的前沿技术，从国内外主流时尚平台及社交平台挖掘时尚素材。从时尚素材收集、流行趋势发现，到新品款式研发、爆款商品预测，为品牌商与平台方客户实现从趋势发现、设计师款式选择、样鞋制作、品牌选样鞋到柔性订单生产的全链路闭环。
						</div>
						<div
							style="font-size: 14px;height: 32px; width: 82px; line-height: 32px; color: white;border: 1px solid #FFFFFF;text-align: center;">
							查看更多</div>
					</div>
					<!-- <div class="col-md-6"> -->
					<img style="width: 50%;" src="../../static/AI流行趋势配图.png" />
					<!-- </div> -->
					<!-- </div> -->
				</div>
			</div>
			<div v-if="selecttabindex!=0"
				style="background: linear-gradient(315deg, #020F39 0%, #263E8B 100%); height: 450px;">
			</div>
		</div>
		<!-- ai tab ad end -->
	</div>

</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/banner1.png'


	export default {
		name: 'club',
		components: {
			firstsceenimage,
			adword,
		},
		data() {
			return {

				imgobj: bigimage,
				aibackimg: require('../../static/盘古大模型开发ai优势bj.png'),
				aibackimg2: require('../../static/盘古大模型开发AI优势水印.png'),
				selecttabindex: 0,

				ai3top: 0,
				ai3show1: false,
				ai3show2: false,
				ai3show3: false,
				
				isShowNavAD:true
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件
			this.ai3top = this.$refs.ai3.offsetTop
			if(window.innerWidth<1200)
			{
			this.isShowNavAD=false
			}
		},
		methods: {
			selecttab: function(e) {
				console.log(e)
				this.selecttabindex = e
			},
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.ai3show1) {
					if (this.vscrolltop > this.ai3top) {
						this.ai3show1 = true;

						setTimeout(() => {
							_this.ai3show2 = true
						}, 200);
						setTimeout(() => {
							_this.ai3show3 = true
						}, 400);
					}
				}

			},




		},
	}
</script>

<style>
	 

	.tabselect {
		background-color: #263E8B;
		height: 36px;
		line-height: 36px;
		color: white;

		width: 180px;
		text-align: center;
	}

	.tabselect2 {
		width: 0px;
		height: 0px;
		border: 8px solid transparent;
		border-top-color: #263E8B;
	}

	.tab {
		text-align: center;
		background-color: #F8F8F8;
		height: 36px;
		line-height: 36px;
		color: black;

		border-top: 1px solid #EAEAEA;
		border-bottom: 1px solid #EAEAEA;
		width: 180px;
	}

	.adfadey1-enter-active {
		transition: all 0.5s;
	}

	.adfadey1-enter {
		opacity: 0;
		transform: translateY(50px);
	}

	.aihuawei {
		animation: fadenum 30s infinite;
	}

	@keyframes fadenum {

		100% {
			transform: rotate(360deg);
		}
	}
</style>
